import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  background: #0a0b0c;
  border-radius: 24px;
  width: 90%;
  max-width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;
  border: 1px solid #18181b;

  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transform: ${({ $isAnimating }) =>
    $isAnimating
      ? "translate(-50%, -50%) scale(1) translateY(0)"
      : "translate(-50%, -50%) scale(0.8) translateY(50px)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  font-family: Figtree;
  letter-spacing: -0.3px;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const ModalContent = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ModalTextBlue = styled.span`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  color: #2877D9;
  font-family: Figtree;
`;
export const ModalText = styled.span`
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-family: Figtree;
`;

export const DiscountBadge = styled.div`
  background: linear-gradient(0deg, #66033c -47.22%, #2877D9 100%);
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  font-family: Figtree;
`;

export const TutorialButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #2877D9;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: Figtree;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
  }
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: -12px;
  font-family: Figtree;
`;

export const ModelNameInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  box-sizing: border-box;
  font-family: Figtree;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    border-color: #2877D9;
    box-shadow: 0 0 0 2px rgba(163, 0, 94, 0.2);
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

export const BackButton = styled.button`
  flex: 1;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: Figtree;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const ContinueButton = styled.button`
  flex: 1;
  background: ${(props) =>
    props.disabled
      ? "rgba(255, 255, 255, 0.1)"
      : "linear-gradient(0deg, #66033c -47.22%, #2877D9 100%)"};
  border: none;
  color: ${(props) => (props.disabled ? "rgba(255, 255, 255, 0.4)" : "#fff")};
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  font-family: Figtree;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(163, 0, 94, 0.3);
  }
`;
